export enum TipoSistema {
  AGENCIAMENTO_CARGA = 'Agenciamento de Carga',
  TRANSPORTE_RODOVIARIO = 'Transporte Rodoviário',
}

export type TipoSistemaKey = keyof typeof TipoSistema;

export function getTipoSistemaKey(value: string | null | undefined): TipoSistemaKey | null {
  if (!value) {
    return null;
  }

  const valorTratado = String(value).trim();

  if (valorTratado in TipoSistema) {
    return valorTratado as TipoSistemaKey;
  }

  const item = (Object.entries(TipoSistema) as [TipoSistemaKey, TipoSistema][]).find(([, descricao]) => descricao === valorTratado);

  return item?.[0] ?? null;
}
